export default __webpack_public_path__ + "static/media/Utric's Shimmering Cloak.ba98f8d8.jpg";